import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  getBeneByRemitter: "",
  getRemitterDetailsForDMT: "",
  addRemiterForDMT: "",
  addBeneForDMT: "",
  pennyDrop: "",
  DmtChargeCalc: "",
  DmtTransct: "",
  getRefundedList: "",
};

const getRemitterDetailsForDMTStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getRemitterDetailsForDMT: "",
    error: "",
  };
};

const getRemitterDetailsForDMTSuccess = (state, data) => {
  return {
    ...state,
    getRemitterDetailsForDMT: data,
    isLoading: false,
    error: "",
  };
};

const getRemitterDetailsForDMTFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//get beni by remiter

const getBeneByRemitterStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getBeneByRemitter: "",
    error: "",
  };
};

const getBeneByRemitterSuccess = (state, data) => {
  return {
    ...state,
    getBeneByRemitter: data,
    isLoading: false,
    error: "",
  };
};

const getBeneByRemitterFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//add Remiter For DMT

const addRemiterForDMTStart = (state) => {
  return {
    ...state,
    isLoading: true,
    addRemiterForDMT: "",
    error: "",
  };
};

const addRemiterForDMTSuccess = (state, data) => {
  return {
    ...state,
    addRemiterForDMT: data,
    isLoading: false,
    error: "",
  };
};

const addRemiterForDMTFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//add Bene For DMT

const addBeneForDMTStart = (state) => {
  return {
    ...state,
    isLoading: true,
    addBeneForDMT: "",
    error: "",
  };
};

const addBeneForDMTSuccess = (state, data) => {
  return {
    ...state,
    addBeneForDMT: data,
    isLoading: false,
    error: "",
  };
};

const addBeneForDMTFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//delete Bene For DMT

const deleteBeneForDMTStart = (state) => {
  return {
    ...state,
    isLoading: true,
    deleteBeneForDMT: "",
    error: "",
  };
};

const deleteBeneForDMTSuccess = (state, data) => {
  return {
    ...state,
    deleteBeneForDMT: data,
    isLoading: false,
    error: "",
  };
};

const deleteBeneForDMTFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//penny drop

const pennyDropStart = (state) => {
  return {
    ...state,
    isLoading: true,
    pennyDrop: "",
    error: "",
  };
};

const pennyDropSuccess = (state, data) => {
  return {
    ...state,
    pennyDrop: data,
    isLoading: false,
    error: "",
  };
};

const pennyDropFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Dmt Charge Calc

const DmtChargeCalcStart = (state) => {
  return {
    ...state,
    isLoading: true,
    DmtChargeCalc: "",
    error: "",
  };
};

const DmtChargeCalcSuccess = (state, data) => {
  return {
    ...state,
    DmtChargeCalc: data,
    isLoading: false,
    error: "",
  };
};

const DmtChargeCalcFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Dmt Transct

const DmtTransctStart = (state) => {
  return {
    ...state,
    isLoading: true,
    DmtTransct: "",
    error: "",
  };
};

const DmtTransctSuccess = (state, data) => {
  return {
    ...state,
    DmtTransct: data,
    isLoading: false,
    error: "",
  };
};

const DmtTransctFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//Dmt Charge Calc

const getRefundedListStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getRefundedList: "",
    error: "",
  };
};

const getRefundedListSuccess = (state, data) => {
  return {
    ...state,
    getRefundedList: data,
    isLoading: false,
    error: "",
  };
};

const getRefundedListFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//reset dmt func

const resetDmtFunc = (state) => {
  return {
    ...state,
    error: "",
    isLoading: "",
    pennyDrop: "",
    DmtTransct: "",
  };
};

const DmtReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMT_START:
      return getRemitterDetailsForDMTStart(state);
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMT_SUCCESS:
      return getRemitterDetailsForDMTSuccess(state, action.data);
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMT_FAIL:
      return getRemitterDetailsForDMTFail(state, action.err);
    case actionTypes.GET_BENI_BY_REMITTER_START:
      return getBeneByRemitterStart(state);
    case actionTypes.GET_BENI_BY_REMITTER_SUCCESS:
      return getBeneByRemitterSuccess(state, action.data);
    case actionTypes.GET_BENI_BY_REMITTER_FAIL:
      return getBeneByRemitterFail(state, action.err);
    case actionTypes.ADD_REMITTER_FOR_DMT_START:
      return addRemiterForDMTStart(state);
    case actionTypes.ADD_REMITTER_FOR_DMT_SUCCESS:
      return addRemiterForDMTSuccess(state, action.data);
    case actionTypes.ADD_REMITTER_FOR_DMT_FAIL:
      return addRemiterForDMTFail(state, action.err);
    case actionTypes.ADD_BENE_FOR_DMT_START:
      return addBeneForDMTStart(state);
    case actionTypes.ADD_BENE_FOR_DMT_SUCCESS:
      return addBeneForDMTSuccess(state, action.data);
    case actionTypes.ADD_BENE_FOR_DMT_FAIL:
      return addBeneForDMTFail(state, action.err);
    case actionTypes.DELETE_BENE_FOR_DMT_START:
      return deleteBeneForDMTStart(state);
    case actionTypes.DELETE_BENE_FOR_DMT_SUCCESS:
      return deleteBeneForDMTSuccess(state, action.data);
    case actionTypes.DELETE_BENE_FOR_DMT_FAIL:
      return deleteBeneForDMTFail(state, action.err);
    case actionTypes.PENNY_DROP_START:
      return pennyDropStart(state);
    case actionTypes.PENNY_DROP_SUCCESS:
      return pennyDropSuccess(state, action.data);
    case actionTypes.PENNY_DROP_FAIL:
      return pennyDropFail(state, action.err);
    case actionTypes.DMT_CHARGE_CALC_START:
      return DmtChargeCalcStart(state);
    case actionTypes.DMT_CHARGE_CALC_SUCCESS:
      return DmtChargeCalcSuccess(state, action.data);
    case actionTypes.DMT_CHARGE_CALC_FAIL:
      return DmtChargeCalcFail(state, action.err);
    case actionTypes.DMT_TRANSCT_START:
      return DmtTransctStart(state);
    case actionTypes.DMT_TRANSCT_SUCCESS:
      return DmtTransctSuccess(state, action.data);
    case actionTypes.DMT_TRANSCT_FAIL:
      return DmtTransctFail(state, action.err);
    case actionTypes.REFUNDED_LIST_START:
      return getRefundedListStart(state);
    case actionTypes.REFUNDED_LIST_SUCCESS:
      return getRefundedListSuccess(state, action.data);
    case actionTypes.REFUNDED_LIST_FAIL:
      return getRefundedListFail(state, action.err);
    case actionTypes.RESET_DMT_START:
      return resetDmtFunc(state);

    default:
      return state;
  }
};

export default DmtReducer;
